import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import { getUserCollectionForAccount } from "#root/schema/user";
import type { ReactNode } from "react";

import PageLayout from "./layout";

const userCollection = getUserCollectionForAccount("self");

export default function (): ReactNode {
  return (
    <PageLayout title="My Profile">
      <section>
        <h1>My Profile</h1>
        <p>Update your name, phone number, and email address associated with your CloudQuote account.</p>
        <Editor collection={userCollection} id="self"/>
      </section>
    </PageLayout>
  );
}

function Editor(props) {
  return (
    <StandardEditor {...props}>
      <Fields.Set name="name">
        <label>Your Name</label>
        <Fields.FullName required autoComplete="name"/>
        <Fields.Validity/>
      </Fields.Set>
      <Fields.Set name="phone">
        <label>Phone Number</label>
        <Fields.Phone autoComplete="tel"/>
        <Fields.Validity/>
      </Fields.Set>
      <Fields.Set name="email">
        <label>Email Address</label>
        <Fields.Email required autoComplete="email"/>
        <Fields.Validity/>
      </Fields.Set>
    </StandardEditor>
  );
}
